// extracted by mini-css-extract-plugin
export default {"card":"Y4-z"};